import { ComponentProps } from "react";

import { Tag } from "./Tag";

/**
 * Marks a role or permission that activates the manager context. A property rather than a state,
 * so a tag; neutral, as most roles carry it and a warning on every row would warn of nothing.
 */
export const ManagerBadge = (props: ComponentProps<"span">) => <Tag {...props} />;
